import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { InventoryItemViewModel } from 'src/app/models/results/inventory-item-view-model';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilityService } from 'src/app/services/utility.service';
import { environment } from 'src/environments/non-vendor/environment';

@Component({
  selector: 'app-device-info',
  templateUrl: './device-info.component.html',
  styleUrls: ['./device-info.component.scss'],
})
export class DeviceInfoComponent implements OnInit {
  @Input() device: InventoryItemViewModel = new InventoryItemViewModel();
  @Input() includeBottomBorderMobile: boolean = false;
  @Input() isDeviceBeingCompared: boolean = false;
  @Input() checkboxesAreDisabled: boolean = false;

  @Output() onDeviceAddedOrRemoved: EventEmitter<any> = new EventEmitter();

  learnMoreButtonText: string = '';
  learnMoreScreenReaderText: string = '';
  specsHeader: string = '';
  processorLabel: string = '';
  memoryLabel: string = '';
  storageLabel: string = '';
  displayLabel: string = '';
  formFactorsLabel: string = '';
  osTypeLabel: string = '';
  additionalFeaturesLabel: string = '';
  descriptionHeader: string = '';
  additionalDetailsHeader: string = '';
  showAddToCartButton: boolean = false;
  showLearnMoreButton: boolean = false;
  showIncludeLicenseCheckbox: boolean = false;
  formQuantityError = '';
  subscriptionChoice: number = 0;
  subscriptionList: {name: string, value: number}[]= [];
  showInStockInfo: boolean = false;

  constructor(public utilityService: UtilityService, private analytics: AnalyticsService, private confSvc: ConfigService)
    {}

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();
    this.learnMoreButtonText = this.confSvc.getString('deviceLearnMoreButtonText');
    this.learnMoreScreenReaderText = `${this.confSvc.getString('deviceLearnMoreButtonScreenReaderPrefix')}${this.device.productDescShort}`;
    this.specsHeader = this.confSvc.getString('deviceSpecsHeader');
    this.processorLabel = this.confSvc.getString('deviceProcessorLabel');
    this.memoryLabel = this.confSvc.getString('deviceMemoryLabel');
    this.storageLabel = this.confSvc.getString('deviceStorageLabel');
    this.displayLabel = this.confSvc.getString('deviceDisplayLabel');
    this.formFactorsLabel = this.confSvc.getString('formFactorsLabel');
    this.osTypeLabel = this.confSvc.getString('osTypeLabel');
    this.additionalFeaturesLabel = this.confSvc.getString('additionalFeaturesLabel');
    this.descriptionHeader = this.confSvc.getString('deviceDescriptionHeader');
    this.additionalDetailsHeader = this.confSvc.getString('additionalDetailsHeader');
    this.showLearnMoreButton = this.device.vendorURL == '' ? false : true;
    this.showAddToCartButton = this.confSvc.getBool('showAddToCartButton');
    this.showIncludeLicenseCheckbox =
      this.confSvc.getBool('showIncludeEnterpriseLicenseBox') &&
      this.device.osType != 'Chrome Enterprise Upgrade'
        ? true
        : false;
    this.subscriptionList = this.confSvc.getValue("subscriptionLicenses");
    this.subscriptionChoice = this.confSvc.getNum("defaultSubscriptionCheck");
    this.showInStockInfo = this.confSvc.getBool("showInStockInfo");
  }

  learnMoreBtnClick(device: InventoryItemViewModel): void {
    this.analytics.logLearnMoreClick(device);
    if (environment.name.includes('Insight')) {
      this.utilityService.openUrlInNewTab(
        device.vendorURL + '?cosds=chromeselector-click'
      );
    } else this.utilityService.openUrlInNewTab(device.vendorURL);
  }

  compareDevice(device: InventoryItemViewModel): void {
    this.onDeviceAddedOrRemoved.emit(device)
  }

  addToCartClick(device: InventoryItemViewModel, itemQuantity: string): void {
    const integerItemQuantity = parseInt(itemQuantity);
    if (integerItemQuantity > 99999 || integerItemQuantity < 1){
      this.formQuantityError = 'Quantity must be between 1 and 99999.';
    } else {
      this.formQuantityError = '';
      if (this.subscriptionChoice == 0 || this.subscriptionChoice == 1) {
        let addToCartData = {device: { skuNo: device.id, qty: integerItemQuantity }};
        console.log(addToCartData);
        window.parent.postMessage({ type: 'chrome-selector', event: addToCartData },'*');
      } else {
        let addToCartData = { device: { skuNo: device.id, qty: integerItemQuantity },license: { skuNo: this.subscriptionChoice.toString(), qty: integerItemQuantity }};
        console.log(addToCartData);
        window.parent.postMessage({ type: 'chrome-selector', event: addToCartData },'*');
      }
    }
  }
}
